import React, { Component } from 'react';
import '../assets/googleradio.css';
import { cx } from '@emotion/css';
import * as styles from './newQuestionBox.style';
import { title } from './questionWithTextFeild.style';
import QuizIndicator from './QuizIndicator';
import withQuizPic from './hoc/withQuizPic';
import MathParser from './MathParser';





class NewQuestionBox extends Component {
  constructor(props) {
    super(props);

    this.state = {
      answer: '',
      quizPic: this.props.getRandomImage(1),
    };
    this.handleRadioChange = this.handleRadioChange.bind(this);
  }

  handleRadioChange(event) {
    // set the new value of checked radion button to state using setState function which is async funtion
    this.setState({
      answer: event.target.value,
    });
  }

  selectedanswer = (answer, id) => {
    this.props.selected(answer, id);
  };

  componentDidMount() {
    this.setState({
      answer: this.props.selectedanswer1,
      quizPic: this.props.getRandomImage(this.props.questionnumber),
    });
  }

  render() {

    console.log("NewQuestionBox: category prop:", this.props.category);
    const isMathematicsCategory = this.props.category === 'Mathematics' || this.props.category === 'MathBowl';
    console.log("NewQuestionBox: isMathematicsCategory:", isMathematicsCategory);

    return (
      <div className={cx(styles.multiChoice)}>
        <div className="leftpanel">
          <h2 className={cx(title)}>
            <span>Q{this.props.questionnumber}/</span>
            {this.props.questionCount}
          </h2>
          <img className="quiz-img" src={this.state.quizPic} alt="" />
     
          {this.props.questionCount < 50 ? (
            
            <QuizIndicator
               className="mb-0"
               questionCount={this.props.questionCount}
               questionnumber={this.props.questionnumber}
             /> ):""}
          <div className="s-title">
            {/* Render question using MathParser */}
            {isMathematicsCategory ? (
              <MathParser text={this.props.question} />
            ) : (
              this.props.question
            )}
          </div>
   
      
        </div>
       
        <div className="rightpanel">
          <p className="s-title">Select Answer Below </p>
          {this.props.answer.map((text, index) => (
            <label className={cx(styles.input)} key={index}>
              <div id={this.props.id + index}>
                <input
                  type="radio"
                  key={this.props.id + index}
                  value={text}
                  name={this.props.id}
                  checked={this.state.answer === text}
                  className="radiobutton"
                  onChange={this.handleRadioChange}
                  onClick={() => {
                    this.props.selected(text, this.props.id);
                  }}
                />

                {this.props.category === 'Flags' ? (
                  <div className="flags">{' ' + text}</div>
                ) : (
                  <div className="">
                    {/* Render answer using MathParser */}
                    {isMathematicsCategory ? (
                      <MathParser text={text} />
                    ) : (
                      text
                    )}
                  </div>
                )}
              </div>
            </label>
          ))}
          <div className="btn-group">
            
            {this.props.controlButtons}</div>
        </div>

      </div>
    );
  }
}

export default withQuizPic(NewQuestionBox);
